import React, { FC } from 'react';
import styled from 'styled-components';

import { TotalsPointsData } from '../../api/hooks/use-fetch-totals-points';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 0.5rem;
`;

const Points = styled.div<{ color?: string }>`
  color: ${(props) => props.color || 'black'};
  font-size: 2rem;
  text-align: center;
  border: 1px solid grey;
  border-top: none;
  width: 9rem;
  padding: 0.5rem 0;
  border-radius: 0 0 5px 5px;
`;

const TeamWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const TeamName = styled.div<{ bgColor?: string }>`
  padding: 1rem;
  border: 1px solid grey;
  border-radius: 5px 5px 0 0;
  color: white;
  background: ${(props) => props.bgColor || 'white'};
  width: 9rem;
  text-align: center;
`;

const TeamDetail = styled.div`
  margin: 0.5rem 0.5rem 0;
`;

type Props = {
  teamTotals: TotalsPointsData;
};
export const TeamPoints: FC<Props> = ({ teamTotals }): JSX.Element => {
  return (
    <div>
      <Wrapper data-testid="page-wrapper">
        <div>
          <TeamName bgColor="red">
            <h3 data-testid="team-1-name">{teamTotals.team1Name}</h3>
          </TeamName>
          <Points color="red" data-testid="team1-points">
            {teamTotals.totalsPoints.team1Points}
          </Points>
          <TeamDetail>
            <TeamWrapper>
              <div></div>
              <div>
                <strong>(w-l-h)</strong>
              </div>
            </TeamWrapper>
            {teamTotals.totalsPoints.team1Individual.map((player, index) => (
              <TeamWrapper key={`team1-${index}`}>
                <div data-testid={`team1-player-${index}`}>{player.player.nickName}</div>
                <div data-testid={`team1-player-matches-${index}`}>{`(${player.won}-${player.lost}-${player.halved})`}</div>
              </TeamWrapper>
            ))}
          </TeamDetail>
        </div>
        <div>
          <TeamName bgColor="blue">
            <h3 data-testid="team-2-name">{teamTotals.team2Name}</h3>
          </TeamName>
          <Points color="blue" data-testid="team2-points">
            {teamTotals.totalsPoints.team2Points}
          </Points>
          <TeamDetail>
            <TeamWrapper>
              <div></div>
              <div>
                <strong>(w-l-h)</strong>
              </div>
            </TeamWrapper>
            {teamTotals.totalsPoints.team2Individual.map((player, index) => (
              <TeamWrapper key={`team1-${index}`}>
                <div data-testid={`team2-player-${index}`}>{player.player.nickName}</div>
                <div data-testid={`team2-player-matches-${index}`}>{`(${player.won}-${player.lost}-${player.halved})`}</div>
              </TeamWrapper>
            ))}
          </TeamDetail>
        </div>
      </Wrapper>
    </div>
  );
};
